import { createContext, useContext, useEffect, useState } from "react";

// Create the context
const GuarantorContext = createContext();

// Hook for using the context
export const useGuarantor = () => useContext(GuarantorContext);

// Provider component
export const GuarantorProvider = ({ children }) => {
  const [guarantor, setGuarantor] = useState(() => {
    const stored = localStorage.getItem("guarantor");
    return stored ? JSON.parse(stored) : null;
  });

  useEffect(() => {
    if (guarantor) {
      localStorage.setItem("guarantor", JSON.stringify(guarantor));
    } else {
      localStorage.removeItem("guarantor");
    }
  }, [guarantor]);

  return (
    <GuarantorContext.Provider value={{ guarantor, setGuarantor }}>
      {children}
    </GuarantorContext.Provider>
  );
};
